import React from 'react'

const Data1 = () => {
  return (
    <div className='data1 p-3'>
        <h1>Our Vision Statement</h1>
        <p>A world of enabled and connected little minds, building future.</p>
        <h1>Our Mission Statement</h1>
        <h3>Statement</h3>
        <p>To inspire students, help them innovate and let them integrate to build the next generation humankind.</p>
        <div className="container">
            <div className="row">
                <div className="col">
                    <h3>Inspire</h3>
                    <p>To inspire, motivate and encourage students to learn, create and help build a better society.</p>
                </div>
                <div className="col">
                    <h3>Innovate</h3>
                    <p>To teach new ways of thinking, to innovate and solve the problems on their own.</p>
                </div>
                <div className="col">
                    <h3>Integrate</h3>
                    <p>To let the students integrate, and help each other, learn from each other and do well together.</p>
                </div>
            </div>
            <h1>Our Values</h1>
            <div className="row">
                <div className="col-lg-3 col-md-6">
                    <h3>Resilience</h3>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h3>Respect</h3>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h3>Excellence</h3>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h3>Commitment</h3>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h3>People</h3>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h3>Quality</h3>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h3>Integrity</h3>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h3>Training</h3>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h3>Professionalism</h3>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Data1